import axios from 'axios';
import UrlConfig from '@/api/base-url.js';
export default {
    data() {
      return {
        timer:null,
        sendTimeEnd:-1,
        sendDisable:false,

        sendCodeText:"",
        showCodeDialog:false,
      }
    },
    computed:{
      sendText(){
        if( typeof this.sendCodeText === "number"){
          return this.sendCodeText;
        } else{
          return "發送驗證碼"
        }
      }
    },
    mounted(){
        let loaclTimeName=this.codePage + '_sendTimeEnd'
        let timeEnd=localStorage.getItem(loaclTimeName);
        let sendTimeEnd = timeEnd&&timeEnd!='undefined'? parseFloat(timeEnd):-1
        if(!sendTimeEnd || sendTimeEnd&&new Date().getTime()>sendTimeEnd){
          this.sendTimeEnd=-1;
          this.sendCodeText = ""
          this.sendDisable=false;
        } else{
          this.sendTimeEnd=sendTimeEnd
          this.timerStart();
        }
    },
    methods:{
        getVerifyCode(params){
          this.sendDisable=true;
					let apiUrl=UrlConfig.baseUrl+"/request/api/sms/code";
					axios.post(apiUrl,params,{
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            }
          }).then(response => {
						let res=response.data;
            if (res&&res.success==1) {
              this.sendTimeEnd = new Date().getTime() + 60*1000;//获取60秒后的时间，计算倒计时
              let loaclTimeName=this.codePage + '_sendTimeEnd'
              localStorage.setItem(loaclTimeName,this.sendTimeEnd)
              this.timerStart()
            } else {
              let res_msg = res.msg.replaceAll("#","");
              this.$message.error(res_msg)
              this.sendDisable=false;
            }
          }).finally(() => {
          });
        },
        getEmailVerifyCode(params){
          this.sendDisable=true;
					let apiUrl=UrlConfig.baseUrl+"/request/api/mail/sendcode";
					axios.post(apiUrl,params,{
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            }
          }).then(response => {
						let res=response.data;
            if (res&&res.success==1) {
              this.sendTimeEnd = new Date().getTime() + 60*1000;//获取60秒后的时间，计算倒计时
              let loaclTimeName=this.codePage + '_sendTimeEnd'
              localStorage.setItem(loaclTimeName,this.sendTimeEnd)
              this.timerStart()
            } else {
							let res_msg = res.msg.replaceAll("#","");
              this.$message.error(res_msg)
              this.sendDisable=false;
            }
          }).finally(() => {
          });
        },
        getRegisterCode(params){
          this.sendDisable=true;
					let apiUrl=UrlConfig.baseUrl+"/request/api/sms/register";
					axios.post(apiUrl,params,{
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            }
          }).then(response => {
						let res=response.data;
						if (res&&res.success==1) {
							this.sendTimeEnd = new Date().getTime() + 60*1000;//获取60秒后的时间，计算倒计时
							let loaclTimeName=this.codePage + '_sendTimeEnd'
							localStorage.setItem(loaclTimeName,this.sendTimeEnd)
							this.timerStart()
						} else {
							let res_msg = res.msg.replaceAll("#","");
							this.$message.error(res_msg)
							this.sendDisable=false;
						}
					})
        },
        getRegisterEmailCode(params){
          this.sendDisable=true;
					let apiUrl=UrlConfig.baseUrl+"/request/api/mail/register";

          axios.post(apiUrl,params,{
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            }
          }).then(res => {
              if (res&&res.success==1) {
                this.sendTimeEnd = new Date().getTime() + 60*1000;//获取60秒后的时间，计算倒计时
                let loaclTimeName=this.codePage + '_sendTimeEnd'
                localStorage.setItem(loaclTimeName,this.sendTimeEnd)
                this.timerStart()
              } else {
                let res_msg = res.msg.replaceAll("#","");
                this.$message.error(res_msg)
                this.sendDisable=false;
              }
            })
        },
        getVerifySubmit(){
          this.sendDisable=true;
          this.sendTimeEnd = new Date().getTime() + 60*1000;//获取60秒后的时间，计算倒计时
          let loaclTimeName=this.codePage + '_sendTimeEnd'
          localStorage.setItem(loaclTimeName,this.sendTimeEnd)
          this.timerStart()
        },
        timerStart() {
            let sendTime= new Date().getTime();
            let timeMS=(this.sendTimeEnd - sendTime)/1000;
            if( !timeMS || typeof timeMS !== "number"){
              timeMS=0;
            }
            this.sendCodeText = Math.round(timeMS);
            this.timer = setInterval(() => {
              if (this.sendCodeText <= 0) {
                  this.sendCodeText = ""
                  this.sendDisable = false
                  this.sendTimeEnd=-1
                  clearInterval(this.timer)
              } else {
                  this.sendCodeText--
              }
            }, 1000)
        },
        submitCode(data){
          this.showCodeDialog=data.Show;
          if(data&&data.Submit){
              this.getVerifySubmit()
          }
       }
    },

}



// WEBPACK FOOTER //
// ./src/mixins/code-countdown.js